export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative h-[400px] lg:h-auto overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Diverse%20collection%20of%20fashion%20items%20artistically%20arranged%20on%20white%20marble%20surface%2C%20bright%20studio%20lighting%20with%20dramatic%20shadows%2C%20high%20fashion%20editorial%20style%2C%20bold%20color%20accents%2C%20luxury%20retail%20aesthetic%2C%20modern%20minimal%20composition%2C%20magazine%20quality%20photography&width=1400&height=1000&seq=cta-left-v3&orientation=landscape"
          alt="AllChinaBuySpreadsheet marketplace products"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
        <span className="absolute top-8 left-8 text-xs font-medium text-white/90 uppercase tracking-[0.2em]">
          Main Marketplace
        </span>
        <div className="absolute bottom-12 left-8">
          <h2 className="text-5xl md:text-7xl font-heading font-bold text-white leading-none tracking-tight">
            ALL<br />CHINA<br />BUY SHEET
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-8 md:px-16 py-16">
        <h2 className="text-5xl md:text-6xl font-heading font-bold text-foreground-950 text-center leading-tight">
          Buy It<br />Now
        </h2>
        <p className="mt-8 text-base text-foreground-600 text-center leading-relaxed max-w-md">
          Ready to start shopping? Visit our main marketplace at KASpreadsheet for the full catalog
          of 14 curated product categories, updated daily with the latest verified listings and
          price comparisons from trusted China suppliers.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-10 inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          Visit KASpreadsheet
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}